import {
  AfterViewInit,
  Attribute,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  Injector,
  Optional,
  ViewChild
} from '@angular/core';
import { CommonModule } from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, WmComponentsModule } from "@wm/components-base";
import { TableComponent } from '../table/table.component';
import { App ,runtimeEventManager} from '@wm/core';
import { debounceTime } from 'rxjs';
import { cloneDeep } from 'lodash-es';
import { FormComponent } from "../form/form.component";

const DEFAULT_CLS = 'app-livegrid';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-livetable',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmLivetable]',
  template: `<ng-content></ng-content>`,
  providers: [
    provideAsWidgetRef(LivetableComponent)
  ],
  exportAs: 'wmLivetable',
  standalone: true,
  imports: [CommonModule, WmComponentsModule],
  styles: []
})
export class LivetableComponent extends StylableComponent implements AfterViewInit {
  static initializeProps = register('wm-livetable');
  @ViewChild('wmTable') table: TableComponent;

  isLayoutDialog: boolean;
  form: FormComponent;
  private dialogId: any;
  private $queue: any[] = [];
  public app: App;

  private tableOptions: any = {
    'multiselect': false,
    'setGridEditMode': ''
  };

  constructor(inj: Injector,
    public elRef: ElementRef,
    public cdr: ChangeDetectorRef,
    @Optional() viewParent: Parent,
    @Attribute('formlayout') layoutType: string,
    @Attribute('dialogid') dialogId: string) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    if (layoutType === 'dialog') {
      this.isLayoutDialog = true;
      this.dialogId = dialogId;
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'formlayout') {
        this.isLayoutDialog = nv === 'dialog';
        if (this.form) {
          this.form.formlayout = nv;
          this.form.isLayoutDialog = this.isLayoutDialog;
          runtimeEventManager.emit('set-markup-attr', {widgetId: this.form.widgetId, 'formlayout': nv});
        }
    }
    super.onPropertyChange(key, nv, ov);
  }

  initLiveTable(table: any) {
    table._liveTableParent = this;
    table.isGridPartOfLiveGrid = true;
  }

  ngAfterContentInit() {
    // super.ngAfterContentInit();
    if (this.table) {
      this.table._liveTableParent = this;
      this.table.datagridElement.datatable('option', this.tableOptions);

      this.table.selectedItemChange$
        .pipe(debounceTime(250))
        .subscribe(this.onSelectedItemChange.bind(this));

      if (!this.isLayoutDialog && !this.form) {
        this.table.datagridElement.datatable('option', {
          'beforeRowUpdate': () => {
            this.showErrorMessage();
          },
          'beforeRowDelete': () => {
            this.showErrorMessage();
          },
          'beforeRowInsert': () => {
            this.showErrorMessage();
          }
        });
      }
    }
  }

  onSelectedItemChange(newValue: any) {
    let rowData;
    if (!this.form || !this.table) {
      return;
    }

    if (newValue && newValue.length > 0 && !this.form.isSelected) {
      this.form.isSelected = true;
    }

    /*Update the rowdata of only that grid form that is associated with the specific grid on which row selection is being performed...
     * Since both the grid & gridform are associated with the same "parentgrid", match the same*/
    if (newValue && newValue.length > 0) {
      if (this.table.multiselect) {
        rowData = newValue[0];
      } else {
        rowData = newValue[newValue.length - 1];
      }

      this.setFormData(cloneDeep(rowData));
      /*If the form is already in update mode, call the form update function*/
      if (this.form.updateMode) {
        // this.form.edit();
      }
    } else {
      this.form.isSelected = false;
      this.setFormData('');
      this.form.clearData();
    }
  }

  setFormData(val: any) {
    // if (!this.form.isDestroyed) {
    //   this.form.getWidget().formdata = val;
    // }
  }

  private _addNewRow() {
    this.form.isSelected = true;
    this.setFormData('');

    // this.form.new();

    // if (this.isLayoutDialog) {
    //   this.onDialogOpen();
    // }
  }

  addNewRow() {
    if (this.isLayoutDialog) {
      // this.openDialog();
      this.$queue.push(this._addNewRow.bind(this));
      return;
    }

    this._addNewRow();
  }

  showErrorMessage() {
    this.app.notifyApp(this.appLocale.LABEL_ACCESS_DENIED, 'error');
  }

  onFormReady(form: FormComponent) {
    this.form = form;
  }
}

